import { debounce } from '@socialive/common';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Select from 'react-select/async';
import { DEFAULT_FILTER_OPTION, FILTER_STORAGE_KEY } from '~/helpers/constants';
import getAccountUsers from '~/store/accountInfo/thunks/getAccountUsers';
import customStyles from './customStyles';
import './UserSelectWithFilter.css';

const UserSelectWithFilter = ({ value, onChange }) => {
  const dispatch = useDispatch();

  const loadOptions = useCallback(
    async (query, callback) => {
      const getUsersResponse = await dispatch(getAccountUsers({ query, trigger: 'UserSelectWithFilter' })).unwrap();
      const userOptions = getUsersResponse?.map((user) => ({ value: user?.user.id, label: user?.user?.name })) ?? [];
      callback([DEFAULT_FILTER_OPTION.HOST, ...userOptions]);
    },
    [dispatch]
  );
  const debounceLoadOptions = useMemo(() => debounce(loadOptions, { ms: 250 }), [loadOptions]);

  const handleOptionChange = useCallback(
    (option) => {
      onChange(option || DEFAULT_FILTER_OPTION.HOST);
    },
    [onChange]
  );
  useEffect(() => {
    sessionStorage.setItem(FILTER_STORAGE_KEY.HOST, JSON.stringify(value));
  }, [value]);

  return (
    <div className="filter">
      <span className="byline filter-title">User: </span>
      <Select
        styles={customStyles}
        loadOptions={debounceLoadOptions}
        onChange={handleOptionChange}
        value={value}
        defaultOptions
        className="select-with-filter"
        noOptionsMessage={({ inputValue }) => (!inputValue ? 'Type to find users' : 'No results found')}
      />
    </div>
  );
};

UserSelectWithFilter.propTypes = {
  value: PropTypes.shape({ value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), label: PropTypes.string })
    .isRequired,
  onChange: PropTypes.func.isRequired,
};

export default UserSelectWithFilter;
